import {AmbiguousErrorLog} from "./ambiguous-error-log.ts";
import {ConsoleLog} from "./console-log.ts";
import type {IAmbiguousErrorLog} from "./types.ts";

/**
 * Create a log based off the environment we're running in.
 *
 * This creates the lowest level log that will properly route logs, errors,
 * and traces.
 */
export const createLog = (): IAmbiguousErrorLog => {
    // We want to allow consumers of our API to log string or Error
    // based errors, so let's wrap with a logger that will map those to
    // our simplified error format.
    return new AmbiguousErrorLog(new ConsoleLog());
};
